import { RootState } from "@app/redux/root-reducer";

export const selectMyMeals = (state: RootState) => state.myMealsReducer.myMeals;